export const UsersMainQueryKey = 'users';

export const UsersQueryKey = {
    Login: [UsersMainQueryKey, 'login'],
    Register: [UsersMainQueryKey, 'register'],
    ResetPassword: [UsersMainQueryKey, 'reset-password'],
    UpdatePassword: [UsersMainQueryKey, 'update-password'],
}